import React, { SVGProps } from "react";

const FontSizeMediumIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#66696D" {...props}>
    <path d="M33.172 35L25.64 16.324h-2.884L15.252 35h2.66l1.652-4.144h9.296L30.512 35h2.66zm-5.012-6.216h-7.924l3.976-10.052 3.948 10.052z" />
  </svg>
);

export default FontSizeMediumIcon;
